import { MultiFormTab, MultiFormTabs } from '@if/mui'
import { useFinancingConfigs } from '@src/data/api/financing-config-api'
import { Merchant } from '@src/data/types/Merchant'
import { MerchantPaymentPlan } from '@src/data/types/MerchantPaymentPlan'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useMerchantGeneralTab } from './tabs/MerchantGeneralTab'
import { useMerchantProgramConfigsTab } from './tabs/MerchantProgramConfigsTab'
import { useMerchantPromotionTab } from './tabs/MerchantPromotionTab'

interface Props {
  merchant: Merchant
  shouldShowGeneralTab: boolean
  shouldShowProgramConfigsTab: boolean
  merchantPaymentPlans: MerchantPaymentPlan[]
  isPaymentPlanFetching: boolean
}

const MerchantTabsForm = ({
  merchant,
  shouldShowGeneralTab,
  shouldShowProgramConfigsTab,
  merchantPaymentPlans,
  isPaymentPlanFetching,
}: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [financingConfigs] = useFinancingConfigs()

  const general = useMerchantGeneralTab(merchant)
  const promotion = useMerchantPromotionTab(merchant, merchantPaymentPlans, isPaymentPlanFetching)
  const programConfigs = useMerchantProgramConfigsTab(merchant, financingConfigs)

  return (
    <MultiFormTabs onCancel={() => navigate(`/merchant/${merchant.id}/view`)}>
      <MultiFormTab
        label={t('merchantSetting.generalSettings')}
        disabled={!shouldShowGeneralTab}
        useFormSetup={general.useFormSetup}
        onSubmit={general.onSubmit}
        onError={general.onError}
      >
        {general.children}
      </MultiFormTab>
      <MultiFormTab
        label={t('merchantSetting.promotionSettings')}
        useFormSetup={promotion.useFormSetup}
        onSubmit={promotion.onSubmit}
      >
        {promotion.children}
      </MultiFormTab>
      <MultiFormTab
        label={t('merchantSetting.financingProgramsSettings')}
        disabled={!shouldShowProgramConfigsTab}
        useFormSetup={programConfigs.useFormSetup}
        onSubmit={programConfigs.onSubmit}
      >
        {programConfigs.children}
      </MultiFormTab>
    </MultiFormTabs>
  )
}

export default memo(MerchantTabsForm)
